import React from 'react';
import { T, useTranslate } from '@tolgee/react';
import { SypacText } from '@sypac/component-library-react';
import FormInput from './FormInput';

const CategoryRow: React.FC<{
	index: number;
	name: string;
	formik: any;
	editFormula: boolean;
}> = ({ index, name, formik, editFormula }) => {
	const { t } = useTranslate();
	const categoryKeys = ['categoryOne', 'categoryTwo', 'categoryThree'];
	const categoryLabels = ['Category 1', 'Category 2', 'Category 3'];

	return (
		<div className="w-full grid grid-cols-[116px,auto]">
			<SypacText variant="body-regular-medium">
				<p className="text-gray-80 mt-[10px]">
					<T keyName={`transportationFormula.${categoryKeys[index]}`}>
						{categoryLabels[index]}
					</T>
				</p>
			</SypacText>
			<span className="flex gap-[14px]">
				<FormInput
					name={`categories.${name}.from`}
					placeholder={t(
						'companyInformationEditable.enterValue',
						'Enter value',
					)}
					formik={formik}
					readOnly={!editFormula}
					className="bg-[#FAFAFA] rounded-[8px] transition hover:bg-white focus:bg-white"
				/>
				<FormInput
					name={`categories.${name}.to`}
					placeholder={t(
						'companyInformationEditable.enterValue',
						'Enter value',
					)}
					formik={formik}
					readOnly={!editFormula}
					className="bg-[#E9F7F5] rounded-[8px] transition hover:bg-white focus:bg-white"
				/>
			</span>
		</div>
	);
};

export default CategoryRow;
